import { styled } from 'troyfe';

const Wrap = styled.div`
    box-sizing: border-box;
    width: 100%;
    height: 100%;

    .custom-style {
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      padding: 20px;
    }

  .add {
    color: #fff;
    margin-left: auto;
    background-color: #44bb55;
  }
  .left {
    display: flex;
    margin-bottom: 10px;
  }
  .operation {
    display: flex;
    align-items: center;
    margin: 0;
    li {
      color: #44bb55;
    }
    i {
      width: 1px;
      background: #999999;
      height: 16px;
      margin: 0 16px;
    }
    .del {
      color: #ff513d;
    }
    li:hover {
      cursor: pointer;
    }
  }
  .ant-pagination {
    margin-top: 8px;
    text-align: right;
  }
  /* .ant-table-selection {
    visibility: hidden;
  } */
`;

const DrawerStyle = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;

  .drawer-top {
    padding: 1.31rem 0;
    border-bottom: 0.06rem solid #f1f2f4;
    h1 {
      text-align: center;
      color: #333333;
      font-size: 1.8rem;
      font-weight: 540;
    }
    .clear {
      float: right;
      font-size: 1rem;
      width: 1.38rem;
      cursor: pointer;
      font-weight: 500;
      margin-right: 2rem;
      transform: scale(1.8);
    }
  }
  .drawer-content {
    flex: 1;
    padding: 20px;
  }
`;

export { Wrap, DrawerStyle };
